import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, resolveImageUrl } from "../lib/config";
import { Handshake } from "lucide-react";

export default function Sponsors() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/sponsors").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="sponsor" className="relative py-20 md:py-28 px-5 md:px-8" data-testid="sponsors-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
            <Handshake size={14} /> Loro credono nel torneo
          </div>
          <h2 className="mt-4 font-heading font-black text-3xl md:text-4xl lg:text-5xl tracking-tight">
            <span className="silver-gradient">I nostri</span>{" "}
            <span className="cyan-gradient">Sponsor</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((s, i) => {
            const CardWrap = s.link_url ? "a" : "div";
            const extra = s.link_url ? { href: s.link_url, target: "_blank", rel: "noopener noreferrer" } : {};
            return (
              <motion.div
                key={s.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.07 }}
                data-testid={`sponsor-${i}`}
              >
                <CardWrap
                  {...extra}
                  className="block p-5 md:p-6 rounded-2xl border border-white/10 bg-fp-surface/40 hover:border-fp-cyan/40 hover:-translate-y-1 transition-all duration-500 group"
                >
                  {s.image_url && (
                    <div className="w-full h-40 md:h-44 rounded-xl bg-white mb-4 overflow-hidden flex items-center justify-center p-3">
                      <img
                        src={resolveImageUrl(s.image_url)}
                        alt={s.title}
                        className="w-full h-full object-contain"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="font-heading font-bold text-base md:text-lg text-white">{s.title}</div>
                  {s.subtitle && (
                    <div className="mt-1 text-white/55 text-sm">{s.subtitle}</div>
                  )}
                </CardWrap>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
